import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';

import styles from './Masthead-style.scss';

const Masthead = ({ isUserTypeTrade }) => {
    const classes = classnames({
        [styles.masthead]: true,
        [styles.isTrade]: isUserTypeTrade,
    });
    return <div className={classes} />;
};

Masthead.propTypes = {
    isUserTypeTrade: PropTypes.bool,
};

const mapStateToProps = ({ header }) => {
    const { isUserTypeTrade } = header;

    return {
        isUserTypeTrade,
    };
};

export default connect(mapStateToProps)(Masthead);
